import { render, staticRenderFns } from "./CardAddAirline.vue?vue&type=template&id=5448d678&"
import script from "./CardAddAirline.vue?vue&type=script&lang=js&"
export * from "./CardAddAirline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports